import { render, staticRenderFns } from "./SideBySide.vue?vue&type=template&id=499dfd32&"
import script from "./SideBySide.vue?vue&type=script&lang=ts&"
export * from "./SideBySide.vue?vue&type=script&lang=ts&"
import style0 from "./SideBySide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports